import classNames from 'classnames'
import { memo, useEffect, useRef, useState, type HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'
import { useGetDiffTimer } from '../../../../hooks/date/use-get-diff-time'

interface Props {
  timeToEnd: string | number | Date
  className?: HTMLAttributes<HTMLSpanElement>['className']
  onFinish?: () => void
}

export const Timer = memo(({ timeToEnd, className, onFinish }: Props) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const { handleCompareDates } = useGetDiffTimer(timeToEnd)

  const [timer, setTimer] = useState(() => {
    return handleCompareDates(new Date(), timeToEnd)
  })

  useEffect(() => {
    if (timeToEnd) {
      intervalRef.current = setInterval(() => {
        setTimer(() => handleCompareDates(new Date(), timeToEnd))
      }, 1000)
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [timeToEnd, handleCompareDates])

  useEffect(() => {
    if (timeToEnd && onFinish) {
      if (timer?.minutes < 0 || timer?.seconds < 0) {
        onFinish?.()
      }
    }
  }, [timeToEnd, timer?.minutes, timer?.seconds, onFinish])

  if (timer?.minutes < 0 || timer?.seconds < 0) {
    return null
  }

  return (
    <span
      className={twMerge(
        classNames('text-white text-xs font-semibold'),
        className,
      )}
    >
      {String(timer?.minutes)?.padStart(2, '0')}:
      {String(timer?.seconds)?.padStart(2, '0')}
    </span>
  )
})

Timer.displayName = 'PkTimer'
